<template>
  <div><pageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'transport-shipmentPayStatement',
  components: { PageTable },
}
</script>
